export default "__VITE_ASSET__CqfZhsmK__"